import React, { useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import RplForm from '../../../components/forms/RplForm';
import { useRplApi } from '../../../hooks/useRplApi';
import { useNavigate } from 'react-router-dom';
import { RplDTO } from '../../../services/apiClient';
import { getRoles } from '../../../utils/tokenUtils';

const RplCreate: React.FC = () => {
  const { create, isLoading } = useRplApi();
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const roles = getRoles();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Rpls', href: '/admin/rpls' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: RplDTO) => {
    try {
      setIsSubmitting(true);
      await create(data);
      handleNavigate();
    } catch (error) {
      console.error('Error creating Rpl:', error);
    } finally{
      setIsSubmitting(false);
    }
  };

  const handleNavigate = () => {
    navigate(-1);
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/dedicatedstatus"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin', 'User']}
      requiredPermission='Manage.Rpl.Edit'
    >
        <RplForm
          initialValues={{} as RplDTO}
          onSubmit={handleSubmit}
          onCancel={handleNavigate}
          isLoading={isSubmitting}
        />
    </AdminLayout>
  );
};

export default RplCreate;